/* ============================================================
   GRACIE — Shopify Theme · Interactions
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     Utilities
  ---------------------------------------------------------- */
  const $  = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));
  const on = (el, evt, fn, opts) => el && el.addEventListener(evt, fn, opts);

  function lockScroll(lock) {
    document.body.classList.toggle('body-locked', !!lock);
  }

  /* ----------------------------------------------------------
     Drawer (cart, mobile nav)
  ---------------------------------------------------------- */
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    d.classList.add('open');
    const overlay = document.querySelector(`[data-drawer-overlay="${id}"]`);
    if (overlay) overlay.classList.add('open');
    lockScroll(true);
    document.dispatchEvent(new CustomEvent('gracie:drawer:open', { detail: { id } }));
  }

  function closeDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    d.classList.remove('open');
    const overlay = document.querySelector(`[data-drawer-overlay="${id}"]`);
    if (overlay) overlay.classList.remove('open');
    if (!document.querySelector('.drawer.open, .mobile-nav.open')) lockScroll(false);
    document.dispatchEvent(new CustomEvent('gracie:drawer:close', { detail: { id } }));
  }

  function closeAllDrawers() {
    $$('.drawer.open, .mobile-nav.open').forEach(d => d.classList.remove('open'));
    $$('.drawer-overlay.open').forEach(o => o.classList.remove('open'));
    lockScroll(false);
  }

  on(document, 'click', e => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      const id = closer.getAttribute('data-drawer-close');
      if (id) closeDrawer(id); else closeAllDrawers();
      return;
    }
    if (e.target.matches('.drawer-overlay')) {
      closeAllDrawers();
    }
  });

  on(document, 'keydown', e => {
    if (e.key === 'Escape') closeAllDrawers();
  });

  window.openDrawer = openDrawer;
  window.closeDrawer = closeDrawer;

  /* ----------------------------------------------------------
     PDP — Color swatch + Size selector
  ---------------------------------------------------------- */
  $$('[data-swatch-row]').forEach(row => {
    on(row, 'click', e => {
      const sw = e.target.closest('.swatch');
      if (!sw || sw.hasAttribute('disabled')) return;
      $$('.swatch', row).forEach(s => s.classList.remove('active'));
      sw.classList.add('active');
      const label = row.parentElement.querySelector('[data-swatch-label]');
      if (label && sw.dataset.label) label.textContent = sw.dataset.label;
      row.dispatchEvent(new CustomEvent('swatch:change', {
        detail: { value: sw.dataset.value, label: sw.dataset.label }
      }));
    });
  });

  $$('[data-size-row]').forEach(row => {
    on(row, 'click', e => {
      const sz = e.target.closest('.size');
      if (!sz || sz.classList.contains('oos') || sz.hasAttribute('disabled')) return;
      $$('.size', row).forEach(s => s.classList.remove('active'));
      sz.classList.add('active');
      row.dispatchEvent(new CustomEvent('size:change', {
        detail: { value: sz.dataset.value }
      }));
    });
  });

  /* ----------------------------------------------------------
     Hero slideshow
  ---------------------------------------------------------- */
  function initHeroSlideshow(slideshow) {
    if (slideshow.__gracieInited) return;
    slideshow.__gracieInited = true;

    const slidesWrap = $('.hero-slides', slideshow);
    const slides = $$('.hero-slide', slideshow);
    const dots   = $$('.hero-dot', slideshow);
    const total  = slides.length;
    if (total <= 1) return;

    const transition = slideshow.dataset.transition || 'fade';
    const autoplayMs = parseInt(slideshow.dataset.autoplay, 10) || 0;
    let current = 0;
    let timer = null;

    function go(idx) {
      idx = ((idx % total) + total) % total;
      if (transition === 'slide' && slidesWrap) {
        slidesWrap.style.transform = `translateX(-${idx * 100}%)`;
      }
      slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
      dots.forEach((d, i) => {
        d.classList.toggle('is-active', i === idx);
        d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
      current = idx;
    }
    function next() { go(current + 1); }
    function prev() { go(current - 1); }
    function start() {
      if (autoplayMs > 0) { stop(); timer = setInterval(next, autoplayMs); }
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    dots.forEach(dot => {
      on(dot, 'click', () => { go(parseInt(dot.dataset.slideTo, 10)); start(); });
    });
    const nextBtn = $('[data-slide-next]', slideshow);
    const prevBtn = $('[data-slide-prev]', slideshow);
    if (nextBtn) on(nextBtn, 'click', () => { next(); start(); });
    if (prevBtn) on(prevBtn, 'click', () => { prev(); start(); });

    on(slideshow, 'mouseenter', stop);
    on(slideshow, 'mouseleave', start);
    on(document, 'visibilitychange', () => { if (document.hidden) stop(); else start(); });

    let startX = 0;
    on(slideshow, 'touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    on(slideshow, 'touchend', e => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { if (dx < 0) next(); else prev(); start(); }
    });

    slideshow.__gracieDestroy = stop;
    start();
  }

  $$('[data-hero-slideshow]').forEach(initHeroSlideshow);

  /* ----------------------------------------------------------
     Announcement bar — rotate mode
  ---------------------------------------------------------- */
  function initAnnounceRotate(rot) {
    if (rot.__gracieInited) return;
    rot.__gracieInited = true;
    const items = $$('.announce-item', rot);
    if (items.length <= 1) return;
    const speedMs = parseInt(rot.dataset.announceSpeed, 10) || 3000;
    let i = 0;
    items.forEach((el, idx) => el.classList.toggle('is-active', idx === 0));
    const t = setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, speedMs);
    rot.__gracieDestroy = () => clearInterval(t);
  }

  $$('[data-announce-rotate]').forEach(initAnnounceRotate);

  /* ----------------------------------------------------------
     Announcement bar — marquee mode (JS-driven)
     - speed in px/sec, constant regardless of content
     - auto-duplicates items so loop is seamless
     - re-measures on resize
  ---------------------------------------------------------- */
  function initAnnounceMarquee(el) {
    if (el.__gracieInited) return;
    el.__gracieInited = true;

    const track = el.querySelector('.announce-track');
    if (!track) return;

    const speedPxPerSec = Math.max(20, parseInt(el.dataset.marqueeSpeed, 10) || 80);
    const original = Array.from(track.children);
    if (original.length === 0) return;

    function setup() {
      // Remove previous clones
      Array.from(track.children).forEach(c => {
        if (c.dataset.cloned === 'true') c.remove();
      });

      // Measure single-set width
      const setWidth = track.scrollWidth;
      if (setWidth === 0) return;

      // Duplicate until track is at least 2× viewport + 1 set
      const target = el.offsetWidth * 2 + setWidth;
      let safety = 0;
      while (track.scrollWidth < target && safety < 60) {
        original.forEach(child => {
          const clone = child.cloneNode(true);
          clone.dataset.cloned = 'true';
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        });
        safety++;
      }

      // Animation distance = one full original-set width (so wrap is seamless)
      const distance = setWidth;
      const duration = distance / speedPxPerSec;
      track.style.setProperty('--marquee-distance', `-${distance}px`);
      track.style.setProperty('--marquee-duration', `${duration}s`);
    }

    // Wait two frames for layout to settle (fonts, etc.)
    requestAnimationFrame(() => requestAnimationFrame(setup));

    // Re-measure on resize (debounced)
    let resizeTimer;
    const onResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        el.__gracieInited = false;
        initAnnounceMarquee(el);
      }, 250);
    };
    on(window, 'resize', onResize);

    // Re-measure when document fonts finish loading (often the cause of marquee being miscalibrated on first paint)
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        requestAnimationFrame(setup);
      });
    }

    el.__gracieDestroy = () => {
      window.removeEventListener('resize', onResize);
    };
  }

  $$('[data-announce-marquee]').forEach(initAnnounceMarquee);

  /* ----------------------------------------------------------
     Shopify Theme Editor — re-init when sections change
  ---------------------------------------------------------- */
  on(document, 'shopify:section:load', e => {
    const root = e.target;
    if (!root) return;
    $$('[data-hero-slideshow]', root).forEach(initHeroSlideshow);
    $$('[data-announce-rotate]', root).forEach(initAnnounceRotate);
    $$('[data-announce-marquee]', root).forEach(initAnnounceMarquee);
  });

  on(document, 'shopify:section:unload', e => {
    const root = e.target;
    if (!root) return;
    $$('[data-hero-slideshow]', root).forEach(el => {
      if (el.__gracieDestroy) el.__gracieDestroy();
    });
    $$('[data-announce-rotate]', root).forEach(el => {
      if (el.__gracieDestroy) el.__gracieDestroy();
    });
    $$('[data-announce-marquee]', root).forEach(el => {
      if (el.__gracieDestroy) el.__gracieDestroy();
    });
  });

  /* ----------------------------------------------------------
     Reveal on scroll
  ---------------------------------------------------------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    $$('[data-reveal]').forEach(el => io.observe(el));
  } else {
    $$('[data-reveal]').forEach(el => el.classList.add('is-revealed'));
  }

  /* ----------------------------------------------------------
     Toast notifications
  ---------------------------------------------------------- */
  function ensureToastStack() {
    let stack = document.getElementById('gracie-toast-stack');
    if (!stack) {
      stack = document.createElement('div');
      stack.id = 'gracie-toast-stack';
      stack.className = 'gracie-toast-stack';
      stack.setAttribute('aria-live', 'polite');
      stack.setAttribute('aria-atomic', 'true');
      document.body.appendChild(stack);
    }
    return stack;
  }
  const Toast = {
    show(msg, kind = '') {
      const stack = ensureToastStack();
      const t = document.createElement('div');
      t.className = 'gracie-toast' + (kind === 'error' ? ' is-error' : '');
      t.textContent = msg;
      stack.appendChild(t);
      setTimeout(() => {
        t.classList.add('is-out');
        setTimeout(() => t.remove(), 320);
      }, 2800);
    }
  };
  window.GracieToast = Toast;

  /* ----------------------------------------------------------
     Cart — Shopify AJAX
  ---------------------------------------------------------- */
  const Cart = {
    fetchCart() {
      return fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
    },
    add(formData) {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' },
        body: formData
      }).then(r => r.json().then(data => ({ ok: r.ok, data })));
    },
    change(line, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line, quantity })
      }).then(r => r.json());
    },
    updateNoteAndAttributes(payload) {
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(r => r.json());
    }
  };
  window.GracieCart = Cart;

  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.gracie_money_format || '${{amount}}');
    }
    return 'Rp ' + (cents / 100).toLocaleString('id-ID', { minimumFractionDigits: 0 });
  }
  window.gracieFormatMoney = formatMoney;

  function refreshCartCount(count) {
    $$('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function refreshCartDrawer() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    fetch('/cart?view=drawer', { credentials: 'same-origin' })
      .then(r => r.text())
      .then(html => {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const fresh = tmp.querySelector('#cart-drawer-inner');
        const target = drawer.querySelector('#cart-drawer-inner');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
      })
      .catch(() => {/* fail silently */});
  }

  /* ---- Add-to-cart from product form ---- */
  on(document, 'submit', e => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    const btn = form.querySelector('[type="submit"]');
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }

    // Build variant summary for confirmation toast — pull selected option labels
    // from the variant picker so user gets clear feedback on what was added.
    let variantSummary = '';
    const picker = document.querySelector('[data-variant-picker]');
    if (picker) {
      const labels = $$('[data-option-set]', picker).map(set => {
        const active = set.querySelector('.swatch.active, .size.active, .filter-pill.active, [aria-checked="true"]');
        return active ? (active.dataset.label || active.dataset.value || active.textContent || '').trim() : '';
      }).filter(Boolean);
      variantSummary = labels.join(' · ');
    }

    Cart.add(fd).then(({ ok, data }) => {
      if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = btn.dataset.label || 'Add to bag'; }
      if (ok) {
        const msg = variantSummary
          ? `${variantSummary} — Added to your bag`
          : 'Added to your bag';
        Toast.show(msg);
        Cart.fetchCart().then(c => refreshCartCount(c.item_count));
        refreshCartDrawer();
        openDrawer('cart-drawer');
      } else {
        Toast.show((data && data.description) || 'Could not add to bag', 'error');
      }
    });
  });

  /* ---- Mobile sticky Add-to-Bag bar trigger ---- */
  on(document, 'click', e => {
    const btn = e.target.closest('[data-pdp-sticky-submit]');
    if (!btn) return;
    e.preventDefault();
    const form = document.querySelector('[data-product-form]');
    if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
  });

  /* ---- Drawer line quantity ---- */
  on(document, 'click', e => {
    const btn = e.target.closest('[data-cart-change]');
    if (!btn) return;
    e.preventDefault();
    const line = parseInt(btn.dataset.line, 10);
    const delta = parseInt(btn.dataset.cartChange, 10);
    const row = btn.closest('[data-cart-line]');
    const currentQty = row ? parseInt(row.dataset.qty, 10) : 1;
    const newQty = Math.max(0, currentQty + delta);
    Cart.change(line, newQty).then(c => {
      refreshCartCount(c.item_count);
      refreshCartDrawer();
      if (newQty === 0) Toast.show('Removed from bag');
    });
  });

  on(document, 'click', e => {
    const btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    e.preventDefault();
    const line = parseInt(btn.dataset.line, 10);
    Cart.change(line, 0).then(c => {
      refreshCartCount(c.item_count);
      refreshCartDrawer();
      Toast.show('Removed from bag');
    });
  });

  /* ----------------------------------------------------------
     Newsletter form (Shopify customer create — newsletter context)
  ---------------------------------------------------------- */
  $$('[data-newsletter-form]').forEach(form => {
    on(form, 'submit', () => {
      // Shopify handles via standard form post; nothing to intercept here unless AJAX desired.
    });
  });

  /* ----------------------------------------------------------
     Predictive search (basic)
  ---------------------------------------------------------- */
  const searchInput = $('[data-predictive-search]');
  const searchPanel = $('[data-search-panel]');
  const searchScrim = $('[data-search-scrim]');
  if (searchPanel) {
    const openSearch = () => {
      searchPanel.hidden = false;
      if (searchScrim) searchScrim.hidden = false;
      requestAnimationFrame(() => {
        searchPanel.classList.add('is-open');
        if (searchScrim) searchScrim.classList.add('is-open');
      });
      if (searchInput) setTimeout(() => searchInput.focus(), 60);
    };
    const closeSearch = () => {
      searchPanel.classList.remove('is-open');
      if (searchScrim) searchScrim.classList.remove('is-open');
      setTimeout(() => {
        searchPanel.hidden = true;
        if (searchScrim) searchScrim.hidden = true;
      }, 280);
    };
    $$('[data-search-toggle]').forEach(btn => on(btn, 'click', e => {
      e.preventDefault();
      searchPanel.classList.contains('is-open') ? closeSearch() : setTimeout(openSearch, 20);
    }));
    $$('[data-search-close]').forEach(btn => on(btn, 'click', closeSearch));
    if (searchScrim) on(searchScrim, 'click', closeSearch);
    on(document, 'keydown', e => { if (e.key === 'Escape' && searchPanel.classList.contains('is-open')) closeSearch(); });
  }
  if (searchInput) {
    let timer;
    on(searchInput, 'input', () => {
      clearTimeout(timer);
      const q = searchInput.value.trim();
      const results = $('[data-predictive-results]');
      if (!q) { if (results) results.innerHTML = ''; return; }
      timer = setTimeout(() => {
        fetch(`/search/suggest?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&section_id=predictive-search`)
          .then(r => r.text())
          .then(html => {
            if (results) {
              const tmp = document.createElement('div');
              tmp.innerHTML = html;
              const inner = tmp.querySelector('[data-predictive-results-inner]');
              results.innerHTML = inner ? inner.innerHTML : '';
            }
          })
          .catch(() => {});
      }, 220);
    });
  }

  /* ----------------------------------------------------------
     PDP — variant picker (color + size → variant_id)
       + gallery image swap when color variant changes
       + sale badge live update
  ---------------------------------------------------------- */
  $$('[data-variant-picker]').forEach(picker => {
    const form = picker.closest('form');
    const variantInput = form ? form.querySelector('input[name="id"]') : null;
    const submitBtn = form ? form.querySelector('[type="submit"]') : null;
    const pdpRoot = picker.closest('.pdp') || document;
    const priceEl = pdpRoot.querySelector('[data-variant-price]');
    const gallery = pdpRoot.querySelector('[data-pdp-gallery]');
    const badgeEl = pdpRoot.querySelector('[data-pdp-badge]');

    let variants = [];
    try { variants = JSON.parse(picker.dataset.variants || '[]'); } catch (e) {}
    // Liquid pre-renders gallery tiles with `data-tile-type="variant"|"shared"`
    // and hides non-current variant tiles via `hidden` attr — JS only toggles on click.

    // Helper: show ONLY current variant's image + all shared shots
    function showVariantImage(variant) {
      if (!gallery || !variant) return;
      const candidateIds = [
        variant.featured_image && variant.featured_image.id,
        variant.featured_media && variant.featured_media.id,
        variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.id
      ].filter(x => x != null).map(String);

      // 1. Hide all "variant" tiles
      gallery.querySelectorAll('[data-tile-type="variant"]').forEach(tile => {
        tile.hidden = true;
        tile.classList.remove('is-active-variant');
      });

      if (candidateIds.length === 0) return;

      // 2. Find and unhide the matching tile for this variant
      let activeTile = null;
      for (const id of candidateIds) {
        const tile = gallery.querySelector(`[data-media-id="${id}"][data-tile-type="variant"]`);
        if (tile) { activeTile = tile; break; }
      }
      if (!activeTile) return;

      activeTile.hidden = false;
      activeTile.classList.add('is-active-variant');

      // 3. Move active variant tile to first slot (so it becomes the hero image)
      if (activeTile !== gallery.firstElementChild) {
        gallery.insertBefore(activeTile, gallery.firstElementChild);
      }
    }

    // Helper: refresh sale badge based on selected variant
    function refreshBadge(variant) {
      if (!variant) return;
      const onSale = variant.compare_at_price != null && variant.compare_at_price > variant.price;
      if (badgeEl) {
        if (onSale) {
          let pct = '';
          if (variant.compare_at_price > 0) {
            const p = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
            if (p > 0) pct = ' · ' + p + '%';
          }
          badgeEl.textContent = 'Sale' + pct;
          badgeEl.style.display = '';
        } else {
          badgeEl.style.display = 'none';
        }
      }
    }

    function updateSelection() {
      const selectedOpts = $$('[data-option-set]', picker).map(set =>
        (set.querySelector('.active') || {}).dataset?.value || null
      );
      const match = variants.find(v =>
        v.options.every((o, i) => selectedOpts[i] == null || selectedOpts[i] === o)
      );
      if (variantInput) variantInput.value = match ? match.id : '';
      if (submitBtn) {
        if (match && match.available) {
          submitBtn.removeAttribute('disabled');
          const label = submitBtn.dataset.labelAdd || 'Add to bag';
          const priceFmt = (match.price_html
            ? match.price_html.replace(/<[^>]+>/g, '')
            : (typeof match.price === 'number' ? formatMoney(match.price) : ''));
          submitBtn.textContent = priceFmt ? `${label} — ${priceFmt}` : label;
        } else {
          submitBtn.setAttribute('disabled', 'disabled');
          submitBtn.textContent = match ? 'Sold out' : 'Unavailable';
        }
      }
      if (priceEl && match) {
        if (match.compare_at_price != null && match.compare_at_price > match.price) {
          const cmpPrice = formatMoney(match.compare_at_price);
          const curPrice = formatMoney(match.price);
          priceEl.innerHTML = `<del>${cmpPrice}</del> <ins>${curPrice}</ins>`;
        } else if (typeof match.price === 'number') {
          priceEl.textContent = formatMoney(match.price);
        }
      }
      showVariantImage(match);
      refreshBadge(match);
    }
    on(picker, 'click', e => {
      if (e.target.closest('.swatch, .size')) {
        // small delay so .active class is applied first
        setTimeout(updateSelection, 0);
      }
    });
    updateSelection();
  });

  /* ----------------------------------------------------------
     Smooth scroll to anchors
  ---------------------------------------------------------- */
  on(document, 'click', e => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;
    const id = a.getAttribute('href').slice(1);
    if (!id) return;
    const target = document.getElementById(id);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  /* ----------------------------------------------------------
     Reorder — add all items from a past order to cart
  ---------------------------------------------------------- */
  on(document, 'click', e => {
    const btn = e.target.closest('[data-reorder]');
    if (!btn) return;
    e.preventDefault();
    const raw = btn.dataset.items || '';
    const items = raw.split(',').filter(Boolean).map(part => {
      const [id, qty] = part.split(':');
      return { id: parseInt(id, 10), quantity: parseInt(qty, 10) || 1 };
    }).filter(it => it.id);
    if (items.length === 0) return;

    btn.setAttribute('aria-disabled', 'true');
    const original = btn.textContent;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    })
    .then(r => r.json().then(data => ({ ok: r.ok, data })))
    .then(({ ok, data }) => {
      btn.removeAttribute('aria-disabled');
      btn.textContent = original;
      if (ok) {
        Toast.show('Reordered to your bag');
        Cart.fetchCart().then(c => refreshCartCount(c.item_count));
        refreshCartDrawer();
        openDrawer('cart-drawer');
      } else {
        Toast.show((data && data.description) || 'Some items could not be added', 'error');
      }
    })
    .catch(() => {
      btn.removeAttribute('aria-disabled');
      btn.textContent = original;
      Toast.show('Something went wrong', 'error');
    });
  });

  /* ----------------------------------------------------------
     Wishlist count (localStorage) — placeholder for Phase 2
  ---------------------------------------------------------- */
  function refreshWishlistCount() {
    let count = 0;
    try {
      const stored = JSON.parse(localStorage.getItem('gracie_wishlist') || '[]');
      count = Array.isArray(stored) ? stored.length : 0;
    } catch (e) {}
    $$('[data-wishlist-count]').forEach(el => { el.textContent = count; });
  }
  refreshWishlistCount();
  on(window, 'storage', e => { if (e.key === 'gracie_wishlist') refreshWishlistCount(); });

  /* ----------------------------------------------------------
     Form save toast — show "Saved" after successful customer/address form submit
  ---------------------------------------------------------- */
  if (document.querySelector('.form-success')) {
    setTimeout(() => Toast.show('Saved'), 200);
  }

  /* ----------------------------------------------------------
     Site-top coordination
     - Mirrors header's data-sticky + data-overlay-home onto the
       .site-top wrapper so the WHOLE stack (announce + nav) can be
       sticky together — the only way to escape Shopify's per-section
       wrapper limiting sticky scope.
     - Adds `.is-scrolled` once user has scrolled past 4px so overlay
       header can switch from transparent → solid.
  ---------------------------------------------------------- */
  (function siteTopController() {
    const siteTop = document.querySelector('[data-site-top]');
    const header = document.querySelector('[data-header]');
    if (!siteTop || !header) return;

    const isSticky = header.dataset.sticky === 'true';
    const isOverlayConfig = header.dataset.overlayHome === 'true';
    const isHome = document.body.classList.contains('template-index');
    const useOverlay = isOverlayConfig && isHome;

    if (useOverlay) {
      siteTop.classList.add('is-overlay');
      document.body.classList.add('has-overlay-header');
    } else if (isSticky) {
      siteTop.dataset.sticky = 'true';
    }

    // Expose nav height as CSS var so overlay hero can pull up under it.
    function syncNavHeight() {
      const h = header.offsetHeight || 0;
      document.documentElement.style.setProperty('--nav-height', h + 'px');
    }
    syncNavHeight();
    window.addEventListener('resize', syncNavHeight);
    if ('ResizeObserver' in window) {
      new ResizeObserver(syncNavHeight).observe(header);
    }

    function onScroll() {
      const scrolled = window.scrollY > 4;
      siteTop.classList.toggle('is-scrolled', scrolled);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  /* ----------------------------------------------------------
     PDP mobile carousel dots
     - Renders a dot per visible gallery tile on viewports ≤ 900px
     - Scrolls gallery to tile on dot click; updates active dot on scroll
  ---------------------------------------------------------- */
  (function pdpGalleryDots() {
    const gallery = document.querySelector('[data-pdp-gallery]');
    const dotsEl  = document.querySelector('[data-pdp-gallery-dots]');
    if (!gallery || !dotsEl) return;

    function visibleTiles() {
      return Array.from(gallery.querySelectorAll('.pdp-img')).filter(t => !t.hidden);
    }

    function renderDots() {
      dotsEl.innerHTML = '';
      const tiles = visibleTiles();
      if (tiles.length < 2) return; // no dots needed for 0 or 1 tile
      tiles.forEach((tile, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'pdp-gallery-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', `Image ${i + 1} of ${tiles.length}`);
        dot.addEventListener('click', () => {
          gallery.scrollTo({ left: tile.offsetLeft, behavior: 'smooth' });
        });
        dotsEl.appendChild(dot);
      });
    }

    function updateActiveDot() {
      const tiles = visibleTiles();
      if (tiles.length === 0) return;
      const idx = Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth));
      Array.from(dotsEl.children).forEach((d, i) => {
        d.classList.toggle('is-active', i === Math.min(idx, tiles.length - 1));
      });
    }

    renderDots();
    gallery.addEventListener('scroll', updateActiveDot, { passive: true });
    window.addEventListener('resize', renderDots);

    // Re-render dots when variant changes (tiles hide/unhide)
    if ('MutationObserver' in window) {
      new MutationObserver(() => {
        renderDots();
        gallery.scrollLeft = 0;
      }).observe(gallery, { attributes: true, attributeFilter: ['hidden'], subtree: true });
    }
  })();

  /* ----------------------------------------------------------
     PDP mobile sticky Add-to-Bag bar
     - Watch the real Add-to-Bag button; when offscreen, slide up the
       sticky bar at the bottom of the viewport. When back in view,
       slide bar down.
  ---------------------------------------------------------- */
  (function pdpStickyBar() {
    const mainBtn = document.querySelector('[data-pdp-main-button]');
    const stickyBar = document.querySelector('[data-pdp-sticky-bar]');
    if (!mainBtn || !stickyBar) return;
    if (!('IntersectionObserver' in window)) return;

    const io = new IntersectionObserver(entries => {
      const inView = entries[0].isIntersecting;
      const visible = !inView;
      stickyBar.classList.toggle('is-visible', visible);
      stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('has-pdp-sticky-bar', visible);
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
    io.observe(mainBtn);

    // Mirror main button's text + disabled state onto sticky button so they
    // always read the same thing (including the live price as variant changes).
    const stickyBtn = stickyBar.querySelector('[data-pdp-sticky-submit]');
    if (stickyBtn) {
      const sync = () => {
        const disabled = mainBtn.hasAttribute('disabled');
        if (disabled) {
          stickyBtn.setAttribute('disabled', 'disabled');
        } else {
          stickyBtn.removeAttribute('disabled');
        }
        // Mirror the entire button text — main button includes price already
        stickyBtn.textContent = mainBtn.textContent.trim();
      };
      sync();
      new MutationObserver(sync).observe(mainBtn, {
        attributes: true, attributeFilter: ['disabled'],
        childList: true, characterData: true, subtree: true
      });
    }
  })();

  /* ----------------------------------------------------------
     Sync SALE link animation choice from <header> → mobile nav
     - Header gets its `data-sale-anim` from section.settings
     - Mobile-nav snippet can't read section settings, so we mirror
       the value via JS at runtime so both stay in sync.
  ---------------------------------------------------------- */
  (function syncSaleAnimation() {
    const header = document.querySelector('[data-header]');
    if (!header) return;
    const anim = header.getAttribute('data-sale-anim');
    if (!anim) return;
    document.querySelectorAll('#mobile-nav a.nav-link--sale').forEach(a => {
      a.setAttribute('data-sale-anim', anim);
    });
  })();

  /* ----------------------------------------------------------
     Shop filter drawer (mobile only)
     - Toggle <aside.filters> open/closed
     - Click scrim or close button to dismiss
     - Lock body scroll while open
  ---------------------------------------------------------- */
  (function shopFilterDrawer() {
    const filters = document.getElementById('ShopFilters');
    if (!filters) return;

    const scrim = document.querySelector('[data-shop-filter-scrim]');
    const toggleTargets = document.querySelectorAll('[data-shop-filter-toggle]');
    if (!toggleTargets.length) return;

    function setOpen(open) {
      filters.classList.toggle('is-open', open);
      if (scrim) scrim.classList.toggle('is-open', open);
      document.body.classList.toggle('shop-filters-open', open);
      toggleTargets.forEach(btn => btn.setAttribute('aria-expanded', open ? 'true' : 'false'));
    }

    toggleTargets.forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        setOpen(!filters.classList.contains('is-open'));
      });
    });

    if (scrim) {
      scrim.addEventListener('click', () => setOpen(false));
    }

    // Close on Escape
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && filters.classList.contains('is-open')) setOpen(false);
    });
  })();

  /* ----------------------------------------------------------
     Init: hydrate count from server-rendered cart
  ---------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', () => {
    Cart.fetchCart().then(c => refreshCartCount(c.item_count)).catch(() => {});
    refreshWishlistCount();
  });

  /* ----------------------------------------------------------
     Apparel carousel — tabbed horizontal scroller
     - Tab click → hide other tracks, show clicked
     - Underline follows active tab
     - Prev/next buttons scroll by roughly one card width
     - Mobile progress bar reflects current scroll position
  ---------------------------------------------------------- */
  document.querySelectorAll('[data-apparel-section]').forEach(section => {
    const tabsWrap  = section.querySelector('[data-apparel-tabs]');
    const underline = section.querySelector('[data-apparel-underline]');
    const tracks    = section.querySelectorAll('[data-apparel-track]');
    const progressBar = section.querySelector('[data-apparel-progress-bar]');

    // ---- Tab switching ----
    function activateTab(id) {
      const tabs = section.querySelectorAll('[data-apparel-tab]');
      tabs.forEach(t => {
        const active = t.dataset.apparelTab === id;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      tracks.forEach(tr => {
        const active = tr.dataset.apparelTrack === id;
        tr.classList.toggle('is-active', active);
        if (active) {
          tr.hidden = false;
          // reset scroll to start when switching tabs
          const scroll = tr.querySelector('[data-apparel-scroll]');
          if (scroll) scroll.scrollTo({ left: 0, behavior: 'auto' });
          updateProgress(scroll);
          updateNavState(tr);
        } else {
          tr.hidden = true;
        }
      });
      moveUnderline(id);
    }

    function moveUnderline(id) {
      if (!underline || !tabsWrap) return;
      const btn = tabsWrap.querySelector(`[data-apparel-tab="${id}"]`);
      if (!btn) { underline.style.width = '0'; return; }
      const btnRect  = btn.getBoundingClientRect();
      const wrapRect = tabsWrap.getBoundingClientRect();
      underline.style.left  = (btnRect.left - wrapRect.left) + 'px';
      underline.style.width = btnRect.width + 'px';
    }

    if (tabsWrap) {
      tabsWrap.addEventListener('click', e => {
        const btn = e.target.closest('[data-apparel-tab]');
        if (!btn) return;
        activateTab(btn.dataset.apparelTab);
      });
      // set initial underline position (after fonts/layout settle)
      const firstActive = tabsWrap.querySelector('[data-apparel-tab].is-active');
      if (firstActive) {
        requestAnimationFrame(() => moveUnderline(firstActive.dataset.apparelTab));
      }
      window.addEventListener('resize', () => {
        const active = tabsWrap.querySelector('[data-apparel-tab].is-active');
        if (active) moveUnderline(active.dataset.apparelTab);
      });
    }

    // ---- Per-track carousel wiring ----
    tracks.forEach(track => {
      const scroll = track.querySelector('[data-apparel-scroll]');
      const prev   = track.querySelector('[data-apparel-prev]');
      const next   = track.querySelector('[data-apparel-next]');
      if (!scroll) return;

      function step() {
        const first = scroll.querySelector('.apparel-item');
        if (!first) return scroll.clientWidth * 0.9;
        const rect = first.getBoundingClientRect();
        const gap  = parseFloat(getComputedStyle(scroll).columnGap || getComputedStyle(scroll).gap) || 0;
        return rect.width + gap;
      }

      if (prev) prev.addEventListener('click', () => {
        scroll.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', () => {
        scroll.scrollBy({ left:  step(), behavior: 'smooth' });
      });

      scroll.addEventListener('scroll', () => {
        updateProgress(scroll);
        updateNavState(track);
      }, { passive: true });

      updateProgress(scroll);
      updateNavState(track);
    });

    // ---- Slow auto-play (pauses on hover/touch/focus/off-screen) ----
    if (section.dataset.autoplay === 'true' &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const delay = (parseInt(section.dataset.autoplaySpeed, 10) || 4) * 1000;
      let timer = null, paused = false, visible = false, resumeT = null;

      const activeScroll = () => {
        const t = section.querySelector('.apparel-track.is-active');
        return t ? t.querySelector('[data-apparel-scroll]') : null;
      };
      const tick = () => {
        if (paused || !visible) return;
        const scroll = activeScroll();
        if (!scroll) return;
        const first = scroll.querySelector('.apparel-item');
        if (!first) return;
        const gap = parseFloat(getComputedStyle(scroll).columnGap || getComputedStyle(scroll).gap) || 0;
        const stepW = first.getBoundingClientRect().width + gap;
        const atEnd = scroll.scrollLeft >= scroll.scrollWidth - scroll.clientWidth - 4;
        scroll.scrollTo({ left: atEnd ? 0 : scroll.scrollLeft + stepW, behavior: 'smooth' });
      };
      const start = () => { stop(); timer = setInterval(tick, delay); };
      const stop  = () => { if (timer) clearInterval(timer); timer = null; };
      const pause = () => { paused = true; clearTimeout(resumeT); };
      const resume = (wait) => {
        clearTimeout(resumeT);
        resumeT = setTimeout(() => { paused = false; }, wait || 0);
      };

      section.addEventListener('mouseenter', pause);
      section.addEventListener('mouseleave', () => resume(600));
      section.addEventListener('focusin', pause);
      section.addEventListener('focusout', () => resume(600));
      section.addEventListener('touchstart', pause, { passive: true });
      section.addEventListener('touchend', () => resume(5000), { passive: true });
      section.addEventListener('wheel', () => { pause(); resume(5000); }, { passive: true });
      // Manual tab/arrow use pauses briefly too
      section.addEventListener('click', () => { pause(); resume(5000); });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(entries => {
          visible = entries[0].isIntersecting;
        }, { threshold: 0.35 }).observe(section);
      } else { visible = true; }
      document.addEventListener('visibilitychange', () => {
        document.hidden ? stop() : start();
      });
      start();
    }

    function updateProgress(scroll) {
      if (!progressBar || !scroll) return;
      const activeTrack = section.querySelector('.apparel-track.is-active');
      if (!activeTrack || activeTrack.querySelector('[data-apparel-scroll]') !== scroll) return;
      const total = Math.max(1, scroll.scrollWidth - scroll.clientWidth);
      const ratio = scroll.clientWidth / scroll.scrollWidth;
      const width = Math.max(0.1, Math.min(1, ratio)) * 100;
      const pos   = (scroll.scrollLeft / total) * (100 - width);
      progressBar.style.width = width + '%';
      progressBar.style.left  = pos + '%';
    }

    function updateNavState(track) {
      const scroll = track.querySelector('[data-apparel-scroll]');
      const prev   = track.querySelector('[data-apparel-prev]');
      const next   = track.querySelector('[data-apparel-next]');
      if (!scroll) return;
      const atStart = scroll.scrollLeft <= 2;
      const atEnd   = scroll.scrollLeft >= (scroll.scrollWidth - scroll.clientWidth - 2);
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    }
  });
})();

/* ============================================================
   Welcome popup — first-purchase discount
============================================================ */
(function () {
  const root = document.querySelector('[data-welcome-popup]');
  if (!root) return;
  const KEY = 'gracie_welcome_v1';
  const DAY = 86400000;
  const design = root.dataset.design === 'true';
  let state = null;
  try { state = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
  if (!design && state && (state.done || (state.until && Date.now() < state.until))) return;

  const form = root.querySelector('#wp-form');
  const stepForm = root.querySelector('[data-wp-step="form"]');
  const stepDone = root.querySelector('[data-wp-step="done"]');
  const save = (o) => { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} };

  function open() {
    root.hidden = false;
    requestAnimationFrame(() => root.classList.add('is-open'));
    const inp = root.querySelector('input[type="email"]');
    if (inp) setTimeout(() => inp.focus({ preventScroll: true }), 400);
  }
  function close(remember) {
    root.classList.remove('is-open');
    setTimeout(() => { root.hidden = true; }, 340);
    if (remember !== false && !(state && state.done)) save({ until: Date.now() + 7 * DAY });
  }
  root.querySelectorAll('[data-wp-close]').forEach(b => b.addEventListener('click', () => close()));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !root.hidden) close(); });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } })
        .catch(() => {})
        .finally(() => {
          state = { done: true };
          save(state);
          stepForm.hidden = true;
          stepDone.hidden = false;
        });
    });
  }
  const copy = root.querySelector('[data-wp-copy]');
  if (copy) copy.addEventListener('click', () => {
    const code = root.querySelector('[data-wp-code]').textContent.trim();
    (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(
      () => { copy.textContent = 'Copied ✓'; }, () => { copy.textContent = code; });
  });

  const delay = design ? 800 : Math.max(2, parseInt(root.dataset.delay, 10) || 6) * 1000;
  setTimeout(open, delay);
})();

/* Bag dimension diagram: 3/4 view (45deg) drawn from W x D x H, plus size tabs */
(function () {
  var NS = 'http://www.w3.org/2000/svg';
  function el(tag, attrs, parent) {
    var n = document.createElementNS(NS, tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  function draw(box) {
    var W = parseFloat(box.dataset.w), D = parseFloat(box.dataset.d), H = parseFloat(box.dataset.h);
    var shape = (box.dataset.shape || 'box').toLowerCase();
    if (!(W > 0 && D > 0 && H > 0)) return;
    var uid = 'bd' + Math.random().toString(36).slice(2, 7);
    var svg = el('svg', { viewBox: '0 0 440 340' });
    var defs = el('defs', {}, svg);
    var mk = el('marker', { id: uid, viewBox: '0 0 10 10', refX: 5, refY: 5, markerWidth: 7, markerHeight: 7, orient: 'auto-start-reverse' }, defs);
    el('path', { d: 'M0 1 L10 5 L0 9 z', fill: 'currentColor' }, mk);

    var tote = shape === 'tote';
    var topRatio = 1, botRatio = tote ? 0.8 : (shape === 'shoulder' ? 0.94 : 1);
    var hh = (shape === 'box' ? 0.38 : shape === 'shoulder' ? 0.62 : 0.55) * H;   // handle rise (cm)
    var k = 0.62;                                   // depth foreshortening
    var oc = D * k * 0.7071;                        // 45deg offset (cm)
    var areaW = 250, areaH = 178;
    var s = Math.min(areaW / (W + oc), areaH / (H + oc + hh));
    var u = oc * s, wt = W * s, wb = wt * botRatio, hpx = H * s, hrise = hh * s;
    var x0 = 92 + (areaW - (wt + u)) / 2;           // front top-left x
    var yb = 252, yt = yb - hpx;
    var xlt = x0, xrt = x0 + wt, xlb = x0 + (wt - wb) / 2, xrb = xlb + wb;

    var g = el('g', { 'class': 'bd-bag' }, svg);
    // back handle (tote / shoulder) drawn first
    function loop(xa, ya, xb, yb2, rise, cls) {
      var p = el('path', { d: 'M' + xa + ' ' + ya + ' C' + xa + ' ' + (ya - rise * 1.33) + ' ' + xb + ' ' + (yb2 - rise * 1.33) + ' ' + xb + ' ' + yb2, fill: 'none', 'class': 'bd-handle ' + (cls || '') }, g);
      return p;
    }
    if (tote) {
      loop(xlt + 0.22 * wt + u, yt - u, xlt + 0.78 * wt + u, yt - u, hrise, 'bd-back');
    } else if (shape === 'shoulder') {
      loop(xlt + 0.10 * wt + u * .5, yt - u * .5, xlt + 0.36 * wt + u * .5, yt - u * .5, hrise, 'bd-back');
      loop(xlt + 0.64 * wt + u * .5, yt - u * .5, xlt + 0.90 * wt + u * .5, yt - u * .5, hrise, 'bd-back');
    }
    // faces
    el('path', { d: 'M' + xlt + ' ' + yt + ' L' + xrt + ' ' + yt + ' L' + (xrt + u) + ' ' + (yt - u) + ' L' + (xlt + u) + ' ' + (yt - u) + ' Z', 'class': 'bd-top' }, g);
    el('path', { d: 'M' + xrt + ' ' + yt + ' L' + (xrt + u) + ' ' + (yt - u) + ' L' + (xrb + u) + ' ' + (yb - u) + ' L' + xrb + ' ' + yb + ' Z', 'class': 'bd-side' }, g);
    var r = Math.min(7, wb * 0.08);
    el('path', { d: 'M' + xlt + ' ' + yt + ' L' + xrt + ' ' + yt + ' L' + xrb + ' ' + (yb - r) + ' Q' + xrb + ' ' + yb + ' ' + (xrb - r) + ' ' + yb + ' L' + (xlb + r) + ' ' + yb + ' Q' + xlb + ' ' + yb + ' ' + xlb + ' ' + (yb - r) + ' Z', 'class': 'bd-front' }, g);
    if (shape === 'box') {
      var fy = yt + hpx * 0.34;
      el('path', { d: 'M' + (xlt + (xlb - xlt) * 0.34) + ' ' + fy + ' Q' + (xlt + xrt) / 2 + ' ' + (fy + hpx * 0.08) + ' ' + (xrt - (xrt - xrb) * 0.34) + ' ' + fy, fill: 'none', 'class': 'bd-line' }, g);
      el('circle', { cx: (xlt + xrt) / 2, cy: fy + hpx * 0.055, r: Math.max(3, wt * 0.014), 'class': 'bd-line' }, g);
    } else {
      el('path', { d: 'M' + (xlt + (xlb - xlt) * 0.12) + ' ' + (yt + hpx * 0.14) + ' H' + (xrt - (xrt - xrb) * 0.12), fill: 'none', 'class': 'bd-line bd-soft' }, g);
    }
    // front handle(s)
    if (shape === 'box') {
      loop(xlt + 0.30 * wt + u * .5, yt - u * .5, xlt + 0.70 * wt + u * .5, yt - u * .5, hrise);
    } else if (tote) {
      loop(xlt + 0.22 * wt, yt, xlt + 0.78 * wt, yt, hrise);
    } else {
      loop(xlt + 0.10 * wt, yt, xlt + 0.36 * wt, yt, hrise);
      loop(xlt + 0.64 * wt, yt, xlt + 0.90 * wt, yt, hrise);
    }
    // dimensions
    var dim = el('g', { 'class': 'bd-dim' }, svg);
    var m = 'url(#' + uid + ')';
    function arrow(x1, y1, x2, y2) { el('line', { x1: x1, y1: y1, x2: x2, y2: y2, 'marker-start': m, 'marker-end': m }, dim); }
    function label(x, y, t, rot) {
      var tx = el('text', { x: x, y: y, 'text-anchor': 'middle', 'class': 'bd-t' }, svg);
      if (rot) tx.setAttribute('transform', 'rotate(' + rot + ' ' + x + ' ' + y + ')');
      tx.textContent = t;
    }
    arrow(xlb, yb + 20, xrb, yb + 20);
    label((xlb + xrb) / 2, yb + 42, W + ' cm');
    var lx = Math.min(xlt, xlb) - 22;
    arrow(lx, yt, lx, yb);
    label(lx - 8, (yt + yb) / 2, H + ' cm', -90);
    arrow(xrb + 14, yb + 14, xrb + u + 14, yb - u + 14);
    label(xrb + u + 36, yb - u + 34, D + ' cm');
    box.innerHTML = '';
    box.appendChild(svg);
  }
  document.querySelectorAll('[data-bag-fig]').forEach(draw);
  window.__gracieBagDraw = draw;

  document.querySelectorAll('[data-bag-dim]').forEach(function (root) {
    var tabs = root.querySelectorAll('[data-bag-tab]');
    var panes = root.querySelectorAll('[data-bag-pane]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-bag-tab');
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        panes.forEach(function (p) { p.classList.toggle('is-hidden', p.getAttribute('data-bag-pane') !== id); });
      });
    });
  });
})();
